export enum MessagesRoutesEnum {
    MESSAGES = 'messages'
}
